import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { DeliveryDataForm, DeliveryFilters } from '../../models/Delivery';

const useDeliveryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    // Estados de carga
    const [fetchingGetDeliveries, setFetchingGetDeliveries] = useState(false);
    const [fetchingStoreDelivery, setFetchingStoreDelivery] = useState(false);
    const [fetchingEditDelivery, setFetchingEditDelivery] = useState(false);
    const [fetchingShowDelivery, setFetchingShowDelivery] = useState(false);
    const [fetchingUpdateDelivery, setFetchingUpdateDelivery] = useState(false);
    const [fetchingDeleteDelivery, setFetchingDeleteDelivery] = useState(false);
    const [fetchingChangeStatus, setFetchingChangeStatus] = useState(false);
    const [fetchingGetDeliveriesBySocietyClient, setFetchingGetDeliveriesBySocietyClient] = useState(false);

    // GET - Listar con filtros
    const getDeliveries = (filter: DeliveryFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = queryString
            ? `${EndPoints.DELIVERIES.GET_DELIVERIES}?${queryString}`
            : EndPoints.DELIVERIES.GET_DELIVERIES;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetDeliveries
        });
    };

    // POST - Crear
    const storeDelivery = (delivery: DeliveryDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.DELIVERIES.STORE_DELIVERY,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: delivery,
            setFetching: setFetchingStoreDelivery
        });
    };

    // GET - Obtener para editar
    const editDelivery = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.DELIVERIES.EDIT_DELIVERY.replace(':id', id.toString()),
            setFetching: setFetchingEditDelivery
        });
    };

    // GET - Mostrar detalle completo
    const showDelivery = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.DELIVERIES.SHOW_DELIVERY.replace(':id', id.toString()),
            setFetching: setFetchingShowDelivery
        });
    };

    // PUT - Actualizar
    const updateDelivery = (id: number, delivery: DeliveryDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.DELIVERIES.UPDATE_DELIVERY.replace(':id', id.toString()),
            body: delivery,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateDelivery
        });
    };

    // DELETE - Eliminar
    const deleteDelivery = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.DELIVERIES.DELETE_DELIVERY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteDelivery
        });
    };

    // POST - Cambiar estado (payload puede incluir actual_delivery_date al marcar Entregada)
    const changeDeliveryStatus = (
        id: number,
        status: string,
        events: ServiceEvents = {},
        payload?: { actual_delivery_date?: string }
    ) => {
        const body = payload ? { status, ...payload } : { status };
        doPost({
            ...events,
            url: EndPoints.DELIVERIES.CHANGE_STATUS_DELIVERY.replace(':id', id.toString()),
            body,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingChangeStatus
        });
    };

    // GET - Obtener entregas por sociedad y cliente
    const getDeliveriesBySocietyClient = (societyId: number, clientId: number, events: ServiceEvents = {}) => {
        const url = EndPoints.DELIVERIES.GET_DELIVERIES_BY_SOCIETY_CLIENT
            .replace(':society_id', societyId.toString())
            .replace(':client_id', clientId.toString());

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetDeliveriesBySocietyClient
        });
    };

    return {
        fetchingGetDeliveries,
        fetchingStoreDelivery,
        fetchingEditDelivery,
        fetchingShowDelivery,
        fetchingUpdateDelivery,
        fetchingDeleteDelivery,
        fetchingChangeStatus,
        fetchingGetDeliveriesBySocietyClient,
        getDeliveries,
        storeDelivery,
        editDelivery,
        showDelivery,
        updateDelivery,
        deleteDelivery,
        changeDeliveryStatus,
        getDeliveriesBySocietyClient
    };
};

export default useDeliveryService;

